"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _ProtoButton = require("./ProtoButton.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * This ProtoButton object is not used in client apps - it sets up the interface for different kinds of buttons.
 * This is largely because different types of buttons (standard, menu, whatever) all have button-like functionality but their presentation may all be vastly different.
 * Styles applied at this level are only those that apply to all things that would be button-like such as the font and the removal of the 'active' outline.
 * These wont look like much from a presentation perspective.
 */
var ProtoButton = _react.default.memo(function (_ref) {
  var active = _ref.active,
      buttonType = _ref.buttonType,
      debounceThreshold = _ref.debounceThreshold,
      children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["active", "buttonType", "debounceThreshold", "children", "className", "dataTestId", "disabled", "onClick"]);

  var clickHandler = buttonType.toLowerCase() === 'submit' && debounceThreshold ? (0, _debounce.default)(onClick, debounceThreshold, {
    leading: true,
    trailing: false
  }) : onClick;
  return /*#__PURE__*/_react.default.createElement(_ProtoButton.StyledProtoButton, _extends({}, props, {
    className: "".concat(className, " ").concat(active ? 'c-button-active' : ''),
    "data-test-id": dataTestId,
    disabled: disabled,
    onClick: clickHandler,
    type: buttonType
  }), children);
});

ProtoButton.propTypes = {
  /** Used to set an active view state via props */
  active: _propTypes.default.bool,

  /** Button Type - can leave as the default unless you are doing a form submission button */
  buttonType: _propTypes.default.string,

  /** Any node(s) that are valid children of an HTML button */
  children: _propTypes2.default.children.isRequired,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Debounce threshold.  Set to 0 (zero) to disable. */
  debounceThreshold: _propTypes.default.number,

  /** Flag to disable the button, impacting visibility and click-ability */
  disabled: _propTypes.default.bool,
  // EVENTS

  /** Function to invoke upon being clicked */
  onClick: _propTypes.default.func
};
ProtoButton.defaultProps = {
  active: false,
  buttonType: 'button',
  className: '',
  debounceThreshold: 500,
  disabled: false,
  onClick: function onClick() {}
};
var _default = ProtoButton;
exports.default = _default;